export enum PromotionStatusEnum {
	PENDING = 'PENDING',
	ACTIVE = 'ACTIVE',
	FINISHED = 'FINISHED',
}

export enum PromotionProductEnum {
	BOOST = 'BOOST',
	COINS = 'COINS',
	INCOGNITO = 'INCOGNITO',
}

export enum PromoCodeBonusTypeEnum {
	FIXED = 'FIXED',
	PERCENT = 'PERCENT',
}

export enum PromoCodeStatusEnum {
	SCHEDULED = 'SCHEDULED',
	ACTIVE = 'ACTIVE',
	EXPIRED = 'EXPIRED',
	DISABLED = 'DISABLED',
}

export enum AppScreenEnum {
	BUY_COINS = 'BuyCoinScreen',
	INCOGNITO_MODAL = 'IncognitoModal',
	BOOST_MODAL = 'BoostModal',
	REWARD_COINS = 'RewardCoinScreen',
	PAYMENT = 'PaymentProviderListScreen',
	WALLET = 'WalletScreen',
	HOME = 'HomeScreen',
	CHAT = 'ChatScreen',
	ACTIVITY = 'ActivityScreen',
	PROFILE = 'ProfileScreen',
	LIKES = 'LikesScreen',
	VIEWS = 'ViewsScreen',
	FAVORITES = 'FavoritesScreen',
	SETTINGS = 'SettingScreen',
	NOTIFICATIONS = 'NotificationsScreen',
	VERIFICATION = 'VerificationHomeScreen',
	REFERRAL = 'ReferralHomeScreen',
}
